import { HugeiconsIcon } from "@hugeicons/react";
import { Tick02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { Button } from "@workspace/frontend-ui";
import type { CSSProperties, FC } from "react";
import useRewardCenter from "../../actors/useRewardCenter";
import Mascot from "../../assets/Mascot";
import useTranslations from "../../i18n/useTranslations";

const Celebration: FC = () => {
  const {
    state: { celebration, tiers },
    send,
  } = useRewardCenter();
  const t = useTranslations();
  const tier = tiers.find((item) => item.id === celebration?.tierId);
  if (!celebration || !tier) return null;

  return (
    <div
      data-slot="celebration"
      aria-live="polite"
      className="absolute inset-0 z-20 flex flex-col items-center gap-4 overflow-hidden rounded-[inherit] bg-background p-6 text-center"
      style={{ "--glow": tier.badgeLight } as CSSProperties}
    >
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(118%_68%_at_50%_8%,color-mix(in_srgb,var(--glow)_45%,transparent),transparent_70%)]" />
      <Mascot tierName={tier.name} className="relative mt-6 size-32" />
      <div className="relative flex flex-col gap-1">
        <p className="font-semibold text-(--glow) text-xs uppercase tracking-[0.22em]">
          {t("reward_center.celebration.title")}
        </p>
        <p className="font-semibold text-3xl text-foreground">{tier.name}</p>
      </div>
      <ul className="relative flex flex-col gap-2 text-foreground text-sm">
        {celebration.perks.map((perk) => (
          <li key={perk} className="flex items-center gap-2">
            <HugeiconsIcon icon={Tick02Icon} className="size-4 text-primary" />
            {perk}
          </li>
        ))}
      </ul>
      <Button
        size="2xl"
        className="relative mt-auto w-full rounded-full font-semibold text-sm"
        onClick={() => send("rewardCenter", { type: "dismissCelebration" })}
      >
        {t("reward_center.celebration.cta")}
      </Button>
    </div>
  );
};

export default Celebration;
